<template>
  <div class="footer">
    <div class="footer-box">
      <div>
        <img src="../assets/image/logo-light.png" width="360" class="footer-logo"/>
        <p>地址：{{companyInfo.address}}</p>
        <p>电话：{{companyInfo.phone}}</p>
        <p>邮箱：{{companyInfo.mail}}</p>
      </div>
    </div>
    <div class="footer-box">
      <div class="qr-code">
        <img :src="$img + companyInfo.wechatImg">
      </div>
      <div>官方微信</div>
    </div>
    <div class="footer-box">
      <div>Copyright&copy; 2018 - {{getYear}} </div>
      <div>Blueape. All Rights Reserved. 潮州数字蓝猿科技有限公司 版权所有</div>
      <div class="beian-click" @click="to_beian">
        粤ICP备2023112699号
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "myFooter",
    data() {
      return{
        companyInfo:{},
        wechatImg:'',
        getYear:''
      }
    },
    mounted() {
      let timer = new Date()
      this.getYear = timer.getFullYear()
      this.$http.get('/api/company/info/list').then((res) => {
        this.companyInfo = res.data.rows[0]
      }, (error) => {
        console.log(error)
      })
    },
    methods:{
      to_beian() {
        window.open('https://beian.miit.gov.cn/',"_blank")
      }
    }
  }
</script>

<style scoped>
  .footer {
    width: 100%;
    height: 260px;
    background-color: #333;
    position: relative;
    display: flex;
    padding: 0 15%;
    box-sizing: border-box;
    justify-content: space-around;
    align-items: center;
    color: #fff;
  }


  .footer-box {
    width: 350px;
    font-size: 14px;
    box-sizing: border-box;
    text-align: center;
    padding-top: 30px;
  }

  .footer-box p {
    text-align: left;
    line-height: 200%;
  }
  .qr-code {
    width: 100px;
    height: 100px;
    background-color: #fff;
    margin: 25px auto 10px;
  }
  .qr-code img{
    width: 100%;
    height: 100%;
  }
  .footer-logo{
    margin-left: -46px;
  }
  .footer-box:last-child {
    line-height: 26px;
  }
  .beian-click{
    color: #aaa;
    cursor: pointer;
  }
  .beian-click:hover{
    color: #fff;
    text-decoration: underline;
  }

</style>



// WEBPACK FOOTER //
// src/components/myFooter.vue